import moment from 'moment';
import i18n from 'l10n';
import Handlebars from 'handlebars';
require('js/models/userrelatedinfo.model');

    var it = {};
    var cl;

    it.init = function (selector) {
        var handler = function (json) {
            var campaignsEnded = json.ENDED;
            var campaignsScheduled = json.NOT_STARTED;
            var countriesCount = json.COUNTRIES_COUNT;
            var smsCampaign = json.SMS_CAMPAIGN;
            var emailCampaign = json.EMAIL_CAMPAIGN;
            var totalAcquisitions = json.TOTAL_ACQUISITIONS;

            $(selector).find("#campaign-ended-title").text(i18n.t("dashboard.campaigns", {count: campaignsEnded}));
            $(selector).find("#campaign-ended-1").text(campaignsEnded);
            cl = Handlebars.helpers.dynamicFontSize(campaignsEnded, $(selector).find("#campaign-ended-1").data("font-length"));
            $(selector).find("#campaign-ended-1").addClass(cl.toString());
            $(selector).find("#campaign-scheduled-title").text(i18n.t("dashboard.campaignsScheduled", {count: campaignsScheduled}));
            $(selector).find("#campaign-scheduled-1").text(campaignsScheduled);
            $(selector).find("#campaigns-ended-text").text(i18n.t("dashboard.campaigns", {count: campaignsEnded}));
            $(selector).find("#campaigns-ended").text(campaignsEnded);
            $(selector).find("#campaigns-scheduled").text(campaignsScheduled);
            $(selector).find("#countries-count").text(countriesCount);
            $(selector).find("#countries").text(i18n.t("dashboard.countries", {count: countriesCount}));
            $(selector).find("#campaign-sms-1").show().text(smsCampaign);
            cl = Handlebars.helpers.dynamicFontSize(smsCampaign, $(selector).find("#campaign-sms-1").data("font-length"));
            $(selector).find("#campaign-sms-1").addClass(cl.toString());
            $(selector).find("#campaign-email-1").show().text(emailCampaign);
            cl = Handlebars.helpers.dynamicFontSize(emailCampaign, $(selector).find("#campaign-email-1").data("font-length"));
            $(selector).find("#campaign-email-1").addClass(cl.toString());

            //sms sent
            var newSelector = $(".email-sms-report-tile");
            $(newSelector).find("#sms-sent-count_1").text(smsCampaign);
            cl = Handlebars.helpers.dynamicFontSize(smsCampaign, $(newSelector).find("#sms-sent-count_1").data("font-length"));
            $(newSelector).find("#sms-sent-count_1").addClass(cl.toString());

            //email sent
            $(newSelector).find("#email-sent-count_1").text(emailCampaign);
            cl = Handlebars.helpers.dynamicFontSize(emailCampaign, $(newSelector).find("#email-sent-count_1").data("font-length"));
            $(newSelector).find("#email-sent-count_1").addClass(cl.toString());

            $(selector).find("#daysToExpireText").text(json.REMAINING_DAYS >= 0 ? json.REMAINING_DAYS + 1 : 0); // +1 to include the current day
            $("#daysLeftDiv").prop("title", i18n.t("dashboard.remainingDaysTitle", {days: json.REMAINING_DAYS + 1})); // +1 to include the current day

            // Total Acquisitions
            newSelector = $('#totalAcquisitions');
            newSelector.text(totalAcquisitions);
            cl = Handlebars.helpers.dynamicFontSize(totalAcquisitions, newSelector.data("font-length"));
            newSelector.addClass(cl.toString());
        };

        $.getDefaultJSONQ('/CampaignCloud/Report/campaignTile', null, handler);

        var handler2 = function (json) {
            var totalFiles = json;
            //files
            var newSelector = $("#files_tile");
            $(newSelector).find("#files-tile-count").text(totalFiles);
            cl = Handlebars.helpers.dynamicFontSize(totalFiles, $(newSelector).find("#files-tile-count").data("font-length"));
            $(newSelector).find("#files-tile-count").addClass(cl.toString());
            $(newSelector).find("#files-tile-title").text(i18n.t("dashboard.file", {count: totalFiles}));
        };

        $.getDefaultJSONQ('/CampaignCloud/Content/countNumberOfContents', null, handler2);

        var handler3 = function (json) {
            var smsScheduled = json.SCHEDULED_SMS;
            var emailScheduled = json.SCHEDULED_EMAIL;

            //sms scheduled
            var newSelector = $(".email-sms-report-tile");
            $(newSelector).find("#scheduled-sms-1").text(smsScheduled);
            cl = Handlebars.helpers.dynamicFontSize(smsScheduled, $(newSelector).find("#scheduled-sms-1").data("font-length"));
            $(newSelector).find("#scheduled-sms-1").addClass(cl.toString());
            $(newSelector).find("#scheduled-sms-title").attr('title', i18n.t("dashboard.campaignSMSScheduled", {count: emailScheduled}));

            //email scheduled
            $(newSelector).find("#scheduled-email-1").text(emailScheduled);
            cl = Handlebars.helpers.dynamicFontSize(emailScheduled, $(newSelector).find("#scheduled-email-1").data("font-length"));
            $(newSelector).find("#scheduled-email-1").addClass(cl.toString());
            $(newSelector).find("#scheduled-email-title").attr('title', i18n.t("dashboard.campaignemailScheduled", {count: emailScheduled}));
        };

        $.getDefaultJSONQ('/CampaignCloud/Report/countScheduledMessages', null, handler3);

        var handler4 = function (json) {
            var totalVouchers = json.TOTAL_VOUCHERS;
            var surveys = json.TOTAL_SURVEYS;
            var optins = json.TOTAL_OPTINS;

            // Total Vouchers
            var newSelector = $("#vouchersInfoTile1");
            $(newSelector).find("#voucher-sum-1").text(totalVouchers);
            cl = Handlebars.helpers.dynamicFontSize(totalVouchers, $(newSelector).find("#voucher-sum-1").data("font-length"));
            $(newSelector).find("#voucher-sum-1").addClass(cl.toString());
            $(newSelector).find("#voucher-sum-title").text(i18n.t("dashboard.voucher", {count: totalVouchers}));

            // Total Surveys
            newSelector = $("#survey-tile1");
            $(newSelector).find("#total-surveys").text(surveys);
            cl = Handlebars.helpers.dynamicFontSize(surveys, $(newSelector).find("#total-surveys").data("font-length"));
            $(newSelector).find("#total-surveys").addClass(cl.toString());
            $(newSelector).find("#survey-sum-title").text(i18n.t("dashboard.survey", {count: surveys}));

            // Total Optins
            newSelector = $("#optinsInfoTile");
            $(newSelector).find("#optin-sum-text").text(optins);
            cl = Handlebars.helpers.dynamicFontSize(optins, $(newSelector).find("#optin-sum-text").data("font-length"));
            $(newSelector).find("#optin-sum-text").addClass(cl.toString());
            $(newSelector).find("#optin-sum-title").text(i18n.t("dashboard.optin", {count: optins}));
        };

        $.getDefaultJSONQ('/CampaignCloud/Report/countTotalServices', null, handler4);

        var handler5 = function (json) {
            var activeVouchers = json.ACTIVE_VOUCHERS;
            var activeSurveys = json.ACTIVE_SURVEYS;
            var activeOptins = json.ACTIVE_OPTINS;

            // Active Vouchers
            var newSelector = $("#vouchersInfoTile");
            $(newSelector).find("#voucher-active-1").text(activeVouchers);
            cl = Handlebars.helpers.dynamicFontSize(activeVouchers, $(newSelector).find("#voucher-active-1").data("font-length"));
            $(newSelector).find("#voucher-active-1").addClass(cl.toString());
            $(newSelector).find(".voucher-active-title").text(i18n.t("dashboard.voucherActive", {count: activeVouchers}));

            // Active Surveys
            newSelector = $("#survey-tile");
            $(newSelector).find("#survey-active-1").text(activeSurveys);
            cl = Handlebars.helpers.dynamicFontSize(activeSurveys, $(newSelector).find("#survey-active-1").data("font-length"));
            $(newSelector).find("#survey-active-1").addClass(cl.toString());
            $(newSelector).find(".survey-active-title").text(i18n.t("dashboard.activeSurvey", {count: activeSurveys}));

            // Active Optins
            newSelector = $("#activeOptinsInfoTile");
            $(newSelector).find("#optin-active-text").text(activeOptins);
            cl = Handlebars.helpers.dynamicFontSize(activeOptins, $(newSelector).find("#optin-active-text").data("font-length"));
            $(newSelector).find("#optin-active-text").addClass(cl.toString());
            $(newSelector).find(".optin-active-title").text(i18n.t("dashboard.activeOptin", {count: activeOptins}));
        };

        $.getDefaultJSONQ('/CampaignCloud/Report/countCCCActiveAdvancedServices', null, handler5);

        var handler6 = function (geoContacts) {
            var newSelector = $("#geo-tile");
            var totalElem = $(newSelector).find("#geo-contacts-total");
            totalElem.text(geoContacts);
            cl = Handlebars.helpers.dynamicFontSize(geoContacts, totalElem.data("font-length"));
            totalElem.addClass(cl.toString());
            $(newSelector).find("#geo-contacts-title").text(i18n.t("dashboard.geoContacts", {count: geoContacts}));
        };

        $.getDefaultJSONQ('/CampaignCloud/Report/countGeoContacts', null, handler6);

        var handler7 = function (json) {
            var contactsWithEmail = json[0][0];
            var contactsWithMobile = json[0][1];
            var newSelector = $("#conctactswithemail");
            var totalElem = $(newSelector).find("#conctactswithemail-total");
            totalElem.text(contactsWithEmail);
            cl = Handlebars.helpers.dynamicFontSize(contactsWithEmail, totalElem.data("font-length"));
            totalElem.addClass(cl.toString());
            $(newSelector).find("#conctactswithemailText").html(i18n.t("dashboard.withemail"));

            newSelector = $("#contactswithmobile");
            totalElem = $(newSelector).find("#contactswithmobile-total");
            totalElem.text(contactsWithMobile);
            cl = Handlebars.helpers.dynamicFontSize(contactsWithMobile, totalElem.data("font-length"));
            totalElem.addClass(cl.toString());
            $(newSelector).find("#contactswithmobileText").html(i18n.t("dashboard.withmobile"));
        };

        $.getDefaultJSONQ('/CampaignCloud/Report/countContactsWithEmailMobile', null, handler7);

        var handler8 = function (linksTotalCount) {
            var newSelector = $("#links");
            var totalElem = $(newSelector).find("#links-total");
            totalElem.text(linksTotalCount);
            cl = Handlebars.helpers.dynamicFontSize(linksTotalCount, totalElem.data("font-length"));
            totalElem.addClass(cl.toString());
            $(newSelector).find("#links-title").text(i18n.t("dashboard.links", {count: linksTotalCount}));
        };

        $.getDefaultJSONQ('/CampaignCloud/Report/countTotalLinks', null, handler8);

        var engagementSatisfactionHandler = function (userData) {
            var userCreationDate = moment(userData.creationDate.millis).startOf('month').toDate().getTime();
            var dateTo = moment().endOf('month').toDate().getTime();
            var handlerEngagement = function () { //pass null data, so the results will be since the account creation
                return $.ajaxDefaultQ({
                    url: '/CampaignCloud/Report/averageEngagement',
                    type: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({"dateFrom": userCreationDate, "dateTo": dateTo}),
                    dataType: 'json'
                }).done(function (json) {
                }).fail(function (response) {
                    console.log(response);
                });
            };

            var handlerSatisfaction = function () { //pass null data, so the results will be since the account creation
                return $.ajaxDefaultQ({
                    url: '/CampaignCloud/Report/SatisfactionPieChartData',
                    type: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({"dateFrom": userCreationDate, "dateTo": dateTo}),
                    dataType: 'json'
                }).done(function (json) {
                }).fail(function (response) {
                    console.log(response);
                });
            };

            $.when(handlerEngagement(), handlerSatisfaction()).then(function (engagementData, satisfactionData) {
                var totalEngagement = engagementData[0];
                totalEngagement = totalEngagement && (totalEngagement * 100) > 0 ? ((totalEngagement * 100) % 10 === 0 ? parseInt(totalEngagement * 100) : (totalEngagement * 100).toFixed(2)) : '0';

                var totalSatisfaction = satisfactionData[0].happinessScore;
                var totalSatisfactionGreat = satisfactionData[0].greatSatisfactionFrequency;
                var totalSatisfactionOkay = satisfactionData[0].okaySatisfactionFrequency;
                var totalSatisfactionNotGood = satisfactionData[0].notGoodSatisfactionFrequency;
                totalSatisfaction = totalSatisfaction && totalSatisfaction > 0 ? parseInt(totalSatisfaction) === 100 ? 100 : parseFloat(totalSatisfaction).toFixed(2) : 0;

                $("#customer-engagement-count").text(totalEngagement + '%');
                $("#customer-satisfaction-count").text(totalSatisfaction + '%');
                $("#satisfactionGreatPercentage").text(parseFloat(totalSatisfactionGreat).toFixed(0) + '%');
                $("#satisfactionOkayPercentage").text(parseFloat(totalSatisfactionOkay).toFixed(0) + '%');
                $("#satisfactionNotGoodPercentage").text(parseFloat(totalSatisfactionNotGood).toFixed(0) + '%');

                var newSelector = $(".first-tiles");
                cl = Handlebars.helpers.dynamicFontSize(totalEngagement, $(newSelector).find("#customer-engagement-count").data("font-length"));
                $(newSelector).find("#customer-engagement-count").addClass(cl.toString());

                cl = Handlebars.helpers.dynamicFontSize(totalSatisfaction, $(newSelector).find("#customer-satisfaction-count").data("font-length"));
                $(newSelector).find("#customer-satisfaction-count").addClass(cl.toString());
            });
        };

        /* TODO Replace with model fetch */
        $.getDefaultJSONQ('/CampaignCloud/UserInfo', null, engagementSatisfactionHandler);
    };

    $(".heading").bind("click", function () {
        var selector = $(".heading");
        setTimeout(function () {
            if (!selector.hasClass("collapsed")) {
                selector.find("#7hText").text(i18n.t("dashboard.helpaccordionpromptClose"));
            }
            else {
                selector.find("#7hText").text(i18n.t("dashboard.helpaccordionprompt"));
            }
        }, 0);
    });

    export default it;
